import { array, number, object, string, type infer as zInfer } from "zod";

export const getControlPortOptions = {
  name: "getControlPortOptions" as const,
  input: object({}),
  output: object({
    returnReasons: array(object({ id: number(), name: string() })),
  }),
};

export type GetControlPortOptionsOutput = zInfer<
  typeof getControlPortOptions.output
>;
